import React from 'react';
import { Link } from 'react-router-dom';
import { NavItem as NavItemType, ICON_STYLES } from './navigationConfig';
import NotificationBadge from './NotificationBadge';

interface NavItemProps {
  item: NavItemType;
  isActive: boolean;
}

const NavItem: React.FC<NavItemProps> = ({ item, isActive }) => {
  const { path, icon: Icon, label, showBadge } = item;

  // Determine if this is an image icon (string) or React component
  const isImageIcon = typeof Icon === 'string';

  return (
    <Link
      to={path}
      className={`relative text-white transition-[background-color,border-color] duration-150 p-2 sm:mb-3 rounded-lg border will-change-[background-color] ${
        isActive
          ? 'border-coral-pink/30' // Active state with coral border only
          : 'border-transparent hover:bg-[#3D4758] hover:border-coral-pink/20' // Hover state without shadows
      }`}
      title={label}
    >
      {isImageIcon ? (
        <img
          src={Icon as string}
          alt={label}
          className="w-6 h-6 sm:mx-auto opacity-90"
        />
      ) : (
        <Icon
          className="w-6 h-6 sm:mx-auto"
          style={{
            color: ICON_STYLES.interactive // Always use the same color #73869E
          }}
        />
      )}

      {/* Badge indicator for notifications */}
      <NotificationBadge showBadge={showBadge} />
    </Link>
  );
};

export default React.memo(NavItem);